import React from 'react';

const Favorite = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 14 14'
            className={className}
        >
            <g id='Favorite' transform='translate(0 -10.99)'>
                <path
                    id='Path_3165'
                    data-name='Path 3165'
                    d='M14,16.415q0-.326-.471-.406l-4.223-.644L7.412,11.352Q7.253,10.99,7,10.99t-.412.362L4.695,15.366l-4.224.644Q0,16.089,0,16.415a.685.685,0,0,0,.21.423l3.063,3.123-.724,4.411a1.5,1.5,0,0,0-.017.176.538.538,0,0,0,.088.313.3.3,0,0,0,.265.128.69.69,0,0,0,.337-.106L7,22.8l3.778,2.082a.658.658,0,0,0,.336.106.292.292,0,0,0,.257-.128.539.539,0,0,0,.088-.313,1.4,1.4,0,0,0-.008-.176l-.724-4.411,3.054-3.123A.648.648,0,0,0,14,16.415Z'
                    transform='translate(0)'
                />
            </g>
        </svg>
    );
};

export default Favorite;
